module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ded_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ded01#ded01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "pro_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/pro01#pro01"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('br'), _vm._v("MY HOUSE STANDS at the edge of the earth. Together, … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "pt_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/pt01#pt01"
    }
  }, [_vm._v("Part One")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('br'), _vm._v("EVER SINCE I CAN REMEMBER, people have had more than … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#ch02"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('br'), _vm._v("BETWEEN MY PRAYERS and Miss B.’s spooning porridge into Mrs. Ketch’s … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03#ch03"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('br'), _vm._v("LATE IN NOVEMBER we bank the house, always on a … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('br'), _vm._v("THINKING IS SOMETHING that Father says I do entirely too … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('br'), _vm._v("THREE TEAMS OF STURDY horses hitched to three beautiful new … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('br'), _vm._v("MY SATURDAY VISIT with Miss Babineau the following week was … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('br'), _vm._v("EACH SUNDAY AT the Union Church we recite the Apostles’ … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('br'), _vm._v("I SPOKE WITH MOTHER about what went on at Miss … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('br'), _vm._v("ANGELS AND SHEPHERDS, three Wise Men and a Virgin all … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('br'), _vm._v("AUNT FRAN MAY HAVE married into her share of money, … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('br'), _vm._v("PRECIOUS HAS BROUGHT a new book, Dr. A.W. Chase’s Information for … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('br'), _vm._v("AUNT FRAN POKED HER HEAD through the door of the … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('br'), _vm._v("“GET UP! WE’RE GOIN’ to see Miss Ginny. I got … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('br'), _vm._v("REVEREND PINEO ARRIVED this week, his first sermon titled “Forgive … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('br'), _vm._v("AUNT FRAN HAD BUILT a fire in the kitchen stove … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('br'), _vm._v("NOT LONG AFTER (or perhaps because of) the mess at … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('br'), _vm._v("FATHER ASKED ME to help him choose the spot for … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('br'), _vm._v("“GET ME TWO long-handled spoons and grease ’em up good … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('br'), _vm._v("EMBROIDERED SILK ILLUSION. Seed pearls and blown glass beads. Fine … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "pt_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/pt02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('br'), _vm._v("THE FIRST THING I DID upon settling into the house … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('br'), _vm._v("BERTINE TUPPER CAME to the house, pulling her youngest child … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('br'), _vm._v("THE FIRST OFFICIAL MEETING of the Occasional Knitters Society included … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('br'), _vm._v("ONCE AUNT FRAN got wind of the Occasional Knitters Society, … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('br'), _vm._v("ARCHER’S POSTCARD WAS enough to send me back to the … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('br'), _vm._v("MY GREAT-GRANDMOTHER Mrs. Mae Loveless used to say, When you fail … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" "), _c('br'), _vm._v("THERE WAS MUCH COMMOTION in Mr. Gordon’s shop the morning of … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" "), _c('br'), _vm._v("I HAD ARCHER READ Dr. John Cowan’s thoughts concerning sexual congress … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" "), _c('br'), _vm._v("THE NEWS THAT SOMETHING was wrong with Ginny Jessup came … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" "), _c('br'), _vm._v("THERE’S A HUNGER THAT comes with long February nights a … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('br'), _vm._v("WE HAD SUNDAY DINNER at the Bigelow house, Archer, Hart … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" "), _c('br'), _vm._v("WE SET UP THE TINY windmill at the Seaside Centre … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" "), _c('br'), _vm._v("THE PINK MOON, April’s moon, pulls the green of the … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_33"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" "), _c('br'), _vm._v("EVERY BIRTH’S A LESSON.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_34"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" "), _c('br'), _vm._v("I SENT PRECIOUS HOME at first light with strict instructions … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_35"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" "), _c('br'), _vm._v("ARCHER ARRIVED ON A SUNDAY morning at the church. As … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_36"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('br'), _vm._v("FULL MOON, CLEAR SKIES. The Dulsin’ tide. By day the … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_37"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" "), _c('br'), _vm._v("WIDOWED AT THE AGE of nineteen.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "pt_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/pt03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_38"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" "), _c('br'), _vm._v("IT WAS THE FIRST OF August when Mrs. Ketch came to … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_39"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" "), _c('br'), _vm._v("I DIDN’T ATTEND THE FUNERAL. I did, however, leave Wrennie … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_40"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('br'), _vm._v("I RAN ALL THE WAY to Spider Hill, only to … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_41"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" "), _c('br'), _vm._v("THE JOURNEY FROM SCOTS BAY to Boston was uneventful as … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_42"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" "), _c('br'), _vm._v("THE DAY AFTER MY ARRIVAL, Maxine declared that I should … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_43"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" "), _c('br'), _vm._v("A GROUP OF WOMEN, including Rachael and Judith, read from … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_44"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" "), _c('br'), _vm._v("A CASE OF INFLUENZA brought me to Miss B.’s, once.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_45"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" "), _c('br'), _vm._v("HART HAD THE HOUSE open and ready for my arrival.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_46"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" "), _c('br'), _vm._v("WHEN WORD OF THE ARMISTICE came, we met at the … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_47"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" "), _c('br'), _vm._v("BY SPRING, HART WAS coming up to Spider Hill almost … ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "epi_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/epi01#epi01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")]), _vm._v(" "), _c('br'), _vm._v("THERE WASN’T MUCH CALL for three-masted schooners after the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ex_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt_head#r_ex_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Excerpt from "), _c('i', [_vm._v("The Witches of New York")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "id": "ex_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt_2_1#r_ex_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City of Wonders")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "id": "ex_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt_2_2#r_ex_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Call And Response")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "id": "ex_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt_2_3#r_ex_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Knot Of One")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "not_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/not01#not01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes from the Willow Book")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atn_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/atn01#atn01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ack01#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ata01#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cre_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/cre01#cre01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061859649_McKay_adcard#zhead1",
      "id": "zhead2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books by Ami McKay")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/cop01#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0